import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import Fondo from "../../Image/fondo_2.png";
import "../../css/InicioPage/Productos.css"
import { Box, Typography, Container, Grid, CircularProgress } from "@mui/material";
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { Link } from "react-router-dom";

export const PorcentajeInicio = () => {
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [porcentaje, setPorcentaje] = useState([]);
  const { ref, inView } = useInView({
    triggerOnce: true, // Solo una vez
    threshold: 0.3,    // Cuando el 30% sea visible
  });
  

  const fetchSliders = useCallback(async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${backendURL}/api/porcentaje/public`);
      setPorcentaje(response.data.data);
      setLoading(false)
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {

    fetchSliders();

  }, [fetchSliders]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={80} thickness={6} /> {/* Hacemos el CircularProgress más grande */}
        </Box>
      </div>
    );
  }

  return (
    <section
      style={{
        backgroundImage: `url(${Fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '80px 0',
        color: '#fff'
      }}
      ref={ref}
    >
      <Container maxWidth="lg" >


        <Grid container spacing={4} justifyContent="center">
          {porcentaje.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }}  key={index} alignItems="center" justifyContent="center">
              <Box textAlign="center" sx={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>

                <Typography variant="h1" sx={{ fontFamily: 'Montserrat', color: '#1A425B', fontWeight: '700' }}>
                 {item.signo} {inView ? <CountUp end={item.numero} duration={2} /> : 0}
                </Typography>
                <h2 className='tituloconteohome'>
                  {item.titulo1}
                </h2>
               
               <div style={{width:'80%'}}> 
                <h3 className='descripcionconteohome'>
                  {item.titulo2}
                </h3>
                 <h3 className='descripcionconteohome'>
                  {item.titulo3}
                </h3>
                </div>

              </Box>
            </Grid>


          ))}

          <Grid size={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Link to='/contacto' style={{ textDecoration: 'none', color: 'inherit' }}>
              <button className="buttondescripcionseccionhome"> Solicitar cotización</button>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};